export var getCookie = function (key) {
    if (!key) {
        return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
};
export var setCookie = function (key, value, expiryMinutes) {
    if (expiryMinutes === void 0) { expiryMinutes = null; }
    if (!key || /^(?:expires|max\-age|path|domain|secure)$/i.test(key)) {
        return false;
    }
    var expiry = null === expiryMinutes ? null : new Date();
    if (expiry && expiryMinutes) {
        expiry.setTime((new Date()).getTime() + expiryMinutes * 60 * 1000);
    }
    // if domain is set, then it is autoprepended with a dot
    // so do not set domain:)
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value)
        + ';samesite=lax'
        + ';path=/'
        + (expiry ? ';expires=' + expiry.toUTCString() : '');
};
export var removeCookie = function (key) {
    document.cookie = key + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
};
